<template>
  <common-dialog ref="dialog" :title="title" width="1100px" :in-dialog="inDialog">
    <div class="index-tree-box">
      <type-tree ref="tree" auto-h show-action @on-select="treeSelect" @title-click="titleClick" />
      <div class="right-box">
        <list ref="list" common :show-checkbox="multiple" :multiple="multiple" :showTrendTable="false" :modelType="modelType" >
          <template #column>
            <slot name="column" />
            <template v-if="selectable&&!multiple">
              <el-table-column label="操作" align="center" width="60" fixed="right">
                <template slot-scope="{row}">
                  <el-button :disabled="row.DistrictId==NoId" @click="onSelect(row)" type="text">选择</el-button>
                </template>
              </el-table-column>
            </template>
          </template>
        </list>
      </div>
    </div>
    <template slot="footer">
      <slot name="footer">
        <el-button type="primary" @click="selectMultiple" v-if="selectable&&multiple">选择</el-button>
      </slot>
    </template>
  </common-dialog>
</template>
<script>
import commonDialog from "@/components/common/dialog";
import list from "./list";
import listDialogMixins from "@/mixins/listDialog";
import typeTree from "./type/tree";

export default {
  components: { commonDialog, list, typeTree },
  mixins: [listDialogMixins],
  props: {
    title: {
      type: String,
      default: "人员列表",
    },
    modelType: {
      type: String,
      default: "personnelresultrecord",
    },
    selectable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      params: {},
      NoId: 0,
    };
  },
  created(){
   
  },
  methods: {
    getTree(){
        this.$refs.tree.getData();
    },
    getData(params = {}) {
      // console.log('我执行到这');
      // this.NoId = params.NoId;
      this.params = { ...params };
      this.$refs.tree.getData();
      this.$refs.list.getData(this.params);
    
    },
    treeSelect(data) {
      this.$refs.list.getData({ ...this.params, IdChain: data.IdChain });
    },
    titleClick() {
      this.$refs.list.getData({ ...this.params, IdChain: null });
    },
  },
};
</script>